import { TextBody } from '@zappyrent/hundop';
import React from 'react';

import { StyledH3 } from '../TextPageLandlord/TextPageLandlord.styles';

const AffittareStudentiLavoratori = (): JSX.Element => {
  return (
    <>
      <StyledH3 sm="24px" md="24px" lg="24px" tag="h3">
        Affittare casa a studenti e lavoratori
      </StyledH3>
      <TextBody>
        <strong>
          Se sei un proprietario di casa che desidera affittare a studenti e
          lavoratori Zappyrent è la tua piattaforma ideale.
        </strong>{' '}
        Il nostro target principale di inquilino è infatti lo studente Erasmus,
        ma anche lo studente fuori sede o il giovane lavoratore.
      </TextBody>
      <TextBody>
        Selezioniamo gli immobili da proporre sul portale annunci tenendo
        presente questa tipologia di clientela e agevolando, di conseguenza, il
        proprietario nella ricerca degli inquilini per il suo appartamento o la
        stanza che intende dare in locazione.
      </TextBody>
      <TextBody>
        Sappiamo quanto sia complicato, per uno studente fuori sede o per un
        giovane lavoratore, trovare casa in una grande città: il mercato è pieno
        di annunci di appartamenti e stanze, ma i prezzi indicati possono essere
        anche molto difficili da sostenere; spesso, poi, gli immobili sono
        situati in località distanti dalle Università o dai poli aziendali.
      </TextBody>
      <TextBody>
        A tutto ciò si aggiungono quasi sempre i costi di intermediazione, che
        fanno lievitare i prezzi dell’affitto, complicando il rapporto tra
        inquilino e proprietario e rendendo difficoltosa la comunicazione tra
        loro.
      </TextBody>
      <TextBody>
        Il sistema adottato da noi di <strong>Zappyrent</strong> azzera tutti
        questi inconvenienti, perché{' '}
        <strong>
          permette al proprietario di casa di proporre il suo immobile da
          affittare semplicemente pubblicando un annuncio completamente
          gratuito,
        </strong>{' '}
        visibile su internet da un numero illimitato di persone interessate,
        mentre il potenziale inquilino sarà libero di scegliere, tra le diverse
        offerte di immobili disponibili, quella che maggiormente risponde alle
        sue esigenze.
      </TextBody>
      <TextBody>
        Uno <strong>scambio semplice e veloce:</strong> il proprietario
        sceglierà, a sua volta, l’inquilino che ritiene abbia le caratteristiche
        che cerca.
      </TextBody>
      <TextBody>
        Per questo, nella redazione dell’annuncio,{' '}
        <strong>
          ti chiediamo di indicare con precisione quali sono le tue richieste,
        </strong>{' '}
        anche relativamente al numero di coinquilini previsti nell’appartamento.
        In tal modo, potrai usufruire del nostro servizio, ottimizzandone i
        risultati, sia da un punto di vista economico che personale.
      </TextBody>
    </>
  );
};

export default AffittareStudentiLavoratori;
